import { Path, Svg } from 'react-native-svg';

export type CabonlineSeparatorProps = {
  color: string;
};

export const CabonlineSeparator = ({
  color = 'black',
}: CabonlineSeparatorProps) => (
  <Svg
    width={'100%'}
    height={25}
    preserveAspectRatio="none"
    fill="none"
    viewBox="0 0 360 25"
  >
    <Path d="M0 0H360V0C180 55 0 0 0 0V0Z" fill={color}></Path>
  </Svg>
);
